var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2919 4.55556V3.84444C12.2919 2.8488 12.2919 2.35097 12.0981 1.97068C11.9277 1.63617 11.6557 1.36421 11.3212 1.19377C10.9409 1 10.4431 1 9.44744 1H8.02522C7.02957 1 6.53174 1 6.15146 1.19377C5.81695 1.36421 5.54498 1.63617 5.37454 1.97068C5.18077 2.35097 5.18077 2.8488 5.18077 3.84444V4.55556M0.760516 7.24564C1.081 7.55279 4.54585 10.7778 8.73633 10.7778C12.9268 10.7778 16.3916 7.55279 16.7121 7.24564M0.760516 7.24564C0.736328 7.66048 0.736328 8.17018 0.736328 8.82222V12.7333C0.736328 14.2268 0.736328 14.9735 1.02698 15.544C1.28264 16.0457 1.69059 16.4537 2.19235 16.7094C2.76278 17 3.50952 17 5.00299 17H12.4697C13.9631 17 14.7099 17 15.2803 16.7094C15.7821 16.4537 16.19 16.0457 16.4457 15.544C16.7363 14.9735 16.7363 14.2268 16.7363 12.7333V8.82222C16.7363 8.17018 16.7363 7.66048 16.7121 7.24564M0.760516 7.24564C0.79173 6.71031 0.863224 6.33297 1.02698 6.01158C1.28264 5.50982 1.69059 5.10187 2.19235 4.8462C2.76278 4.55556 3.50952 4.55556 5.003 4.55556H12.4697C13.9631 4.55556 14.7099 4.55556 15.2803 4.8462C15.7821 5.10187 16.19 5.50982 16.4457 6.01158C16.6094 6.33297 16.6809 6.71031 16.7121 7.24564",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adminIcon.22ade31948e813b6460e7d1010818b13.svg";